/* eslint-disable no-underscore-dangle */

import { db, auth, functions, firestore } from '@/shared/services/firebase'
import axios from '@hw-core/libs/axios'
import { capitalize } from '@hw-core/utils'
import firebase from 'firebase/app'
import store from '@/shared/store'

import { fetchUsers } from './actions/fetchUsers'

function getStatus(item) {
  const today = new Date()
  let { status } = item
  if (item.end < today && item.status !== 'confirmed') {
    /* if (item.status === 'booked') {
      status = 'unconfirmed'
    } */
  }
  if (item.end > today && item.status === 'booked' && item.reserved) {
    status = 'verified'
  }
  return capitalize(status)
}

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers,
    blockUser(ctx, { blockStatus, blockReason, blocker, blockedFrom, userId }) {
      return new Promise((resolve, reject) => {
        auth.currentUser
          .getIdToken(true)
          .then(idToken => {
            const newBlockedFrom = blockedFrom.map(item => ({
              ...item,
              date: item.date.toString(),
            }))
            let params = {
              blockStatus,
              blockedFrom: newBlockedFrom,
              userId,
              token: idToken,
            }
            if (blockStatus === 'block') {
              params = {
                ...params,
                blockReason,
                blocker,
              }
            }

            axios
              .post(`${functions.url}/blockUser`, params)
              .then(response => resolve(response))
              .catch(error => reject(error))
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        db.collection('users')
          .doc(id)
          .get()
          .then(async doc => {
            if (!doc.exists) {
              reject()
            }
            const data = doc.data()
            data.uid = id
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getShiftsByPersonelId(ctx, { personelId, status, limit, list }) {
      return new Promise((resolve, reject) => {
        
        // Get shifts by assignedTo
        let query = db.collection("shifts")
        .where("assignedTo", "==", personelId)

      if (status === "verified") {
        query = query
            .where("status", "==", "booked").where("reserved", "==", true)
      } else if (status === "booked") {
        query = query
            .where("status", "==", "booked").where("reserved", "==", false)
      } else {
        query = query.where("status", "==", status)
      }

      query = query.orderBy("start", "desc")

      if (list.length >= 10) {
        const startTime = list[list.length - 1].start
        query = query.startAfter(startTime)
      }
      query.get().then(res => {
        let hours = 0
        const allShifts = res.docs.map(doc => {
          const item = doc.data()
          hours += item.start.toDate().getDate() === item.end.toDate().getDate()
            ? item.end.toDate().getHours() - item.start.toDate().getHours()
            : item.start.toDate().getHours() + 24 - item.end.toDate().getHours()
          item.calendar = getStatus(item)
          item.id = doc.id
          return item
        })
        query.limit(limit).get().then(snapshot => {
          const data = snapshot.docs.map(doc => {
            const item = doc.data()
            item.calendar = getStatus(item)
            item.id = doc.id
            return item
          })
          list.push(...data)
          resolve({ data: list, isMore: data.length >= 10, amountOfShifts: allShifts.length, hours })
        })
      })
      .catch(error => {
        reject(error)})
      })
    },
    addUser(ctx, user) {
      return new Promise((resolve, reject) => {
        db.collection('users')
          .add(user)
          .then(docRef => {
            axios
              .post(`${store.state.app.appConfig.type === 'hw-admin' ? functions.url : functions.oiwaUrl}/createUser`, { userId: docRef.id })
              .then(() => {
                resolve(docRef)
              })
              .catch(error => {
                reject(error)
              })
          })
      })
    },
    addUsersFromCsv(ctx, { users }) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const user of users) {
          db.collection('users')
          .add(user)
          .then(docRef => {
            axios
              .post(`${store.state.app.appConfig.type === 'hw-admin' ? functions.url : functions.oiwaUrl}/createUser`, { userId: docRef.id })
              .then(() => {
                resolve(docRef)
              })
              .catch(error => {
                reject(error)
              })
          })
        }
      })
    },
    updateUser(ctx, { id, data, isEmailChanged }) {
      return new Promise((resolve, reject) => {
        db.collection('users')
          .doc(id)
          .update(data)
          .then(() => {
            // eslint-disable-next-line no-unused-expressions
            isEmailChanged
              ? auth.currentUser
                .getIdToken(true)
                .then(token => {
                  axios.post(`${functions.url}/updateUserAuthData`, {
                    userId: id,
                    data: {email: data.email},
                    token
                  }).then(() => {
                    resolve()
                  })
                })
              : resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    deleteUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        db.collection('users')
          .doc(id)
          .update({
            status: 'deleted',
          })
          .then(() => {
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    sendEmailReset(ctx, { email }) {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .sendPasswordResetEmail(email)
          .then(() => {
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    sendAcceptEmail(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/sendAcceptEmail`, { id })
          .then(() => {
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    sendTuberculosisSurvey(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/sendTuberculosisSurvey`, { id })
          .then(() => {
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    isEmailTaken(ctx, { email }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${store.state.app.appConfig.type === 'hw-admin' ? functions.url : functions.oiwaUrl}/checkIfEmailExists`, { email })
          .then(response => resolve(response.data.result))
          .catch(error => reject(error))
      })
    },
    createZendeskTicket(ctx, { requester, groupId, message, subject, collaborators }) {
      return new Promise((resolve, reject) => {
        auth.currentUser
          .getIdToken(true)
          .then(idToken => {
            axios
              .post(`${functions.url}/createZendeskTicket`, {
                requester,
                groupId,
                message,
                subject,
                collaborators,
                token: idToken,
              })
              .then(response => resolve(response))
              .catch(error => reject(error))
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    sendSMS(ctx, { mobile, message }) {
      return new Promise((resolve, reject) => {
        auth.currentUser
          .getIdToken(true)
          .then(idToken => {
            axios
              .post(`${functions.url}/sendSMSMessage`, { to: mobile, message, token: idToken })
              .then(response => resolve(response))
              .catch(error => reject(error))
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateShift(ctx, { id, data, newUpdate }) {
      const newData = {
        ...data,
        updates: firestore.FieldValue.arrayUnion(newUpdate),
      }
  
      return new Promise((resolve, reject) => {
        db.collection('shifts')
          .doc(id)
          .update(newData)
          .then(async () => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
  },
}
